import React from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BUSINESS } from "@/lib/api";

export default function Location() {
  return (
    <section
      id="location"
      data-testid="location-section"
      className="py-20 lg:py-28 bg-slate-50"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-5">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-brand-blue">
            Visit us
          </p>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-brand-navy">
            Your local cleaner on Ray Rd.
          </h2>

          <div className="mt-8 space-y-5">
            <div className="flex items-start gap-4">
              <div className="h-11 w-11 rounded-xl bg-brand-lightblue grid place-items-center text-brand-blue shrink-0">
                <MapPin className="h-5 w-5" />
              </div>
              <div>
                <p className="font-display font-semibold text-brand-navy">Address</p>
                <p className="text-slate-600">{BUSINESS.address}</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="h-11 w-11 rounded-xl bg-brand-lightblue grid place-items-center text-brand-blue shrink-0">
                <Phone className="h-5 w-5" />
              </div>
              <div>
                <p className="font-display font-semibold text-brand-navy">Phone</p>
                <a
                  href={`tel:${BUSINESS.phoneTel}`}
                  data-testid="location-phone-link"
                  className="text-slate-600 hover:text-brand-blue"
                >
                  {BUSINESS.phone}
                </a>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="h-11 w-11 rounded-xl bg-brand-lightblue grid place-items-center text-brand-blue shrink-0">
                <Mail className="h-5 w-5" />
              </div>
              <div>
                <p className="font-display font-semibold text-brand-navy">Email</p>
                <a
                  href={`mailto:${BUSINESS.email}`}
                  data-testid="location-email-link"
                  className="text-slate-600 hover:text-brand-blue break-all"
                >
                  {BUSINESS.email}
                </a>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="h-11 w-11 rounded-xl bg-brand-lightblue grid place-items-center text-brand-blue shrink-0">
                <Clock className="h-5 w-5" />
              </div>
              <div>
                <p className="font-display font-semibold text-brand-navy">Hours</p>
                <ul className="mt-1 space-y-1 text-slate-600">
                  {BUSINESS.hours.map((h) => (
                    <li key={h.label} className="flex gap-3">
                      <span className="w-24 font-medium text-brand-navy">{h.label}</span>
                      <span>{h.value}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <Button
              asChild
              data-testid="location-directions-btn"
              className="rounded-full bg-brand-blue hover:bg-brand-navy text-white h-11 px-6"
            >
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=5865+W+Ray+Rd+%233,+Chandler,+AZ+85226"
                target="_blank"
                rel="noreferrer"
              >
                Get directions
              </a>
            </Button>
            <Button
              asChild
              variant="outline"
              data-testid="location-call-btn"
              className="rounded-full h-11 px-6 border-slate-300"
            >
              <a href={`tel:${BUSINESS.phoneTel}`}>Call the store</a>
            </Button>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="rounded-3xl overflow-hidden border border-slate-200 shadow-sm bg-white">
            <iframe
              data-testid="location-map"
              title="Oxford Cleaners location"
              src="https://www.google.com/maps?q=5865+W+Ray+Rd+%233,+Chandler,+AZ+85226&output=embed"
              className="w-full h-[460px] lg:h-[560px]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
